import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import "./EventDetails.css";

// Countdown component (inside the same file or in a separate file and imported)
const Countdown = ({ targetDate }) => {
    const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const distance = new Date(targetDate).getTime() - now;

        if (distance <= 0) {
            return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        return {
            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((distance % (1000 * 60)) / 1000),
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div className="count-down-time">
            <div className="singel-count">
                <span className="number">{timeLeft.days} :</span>
                <span className="title">Days</span>
            </div>
            <div className="singel-count">
                <span className="number">{timeLeft.hours} :</span>
                <span className="title">Hours</span>
            </div>
            <div className="singel-count">
                <span className="number">{timeLeft.minutes} :</span>
                <span className="title">Minutes</span>
            </div>
            <div className="singel-count">
                <span className="number">{timeLeft.seconds}</span>
                <span className="title">Seconds</span>
            </div>
        </div>
    );
};

const api_url = process.env.REACT_APP_API_URL;

const EventsDetails = () => {
    const { slug } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch event details
    const fetchEventDetails = async () => {
        try {
            const response = await axios.post(`${api_url}/events/events_details.php`, { slug });
            setEvent(response.data.event || response.data);
        } catch (err) {
            console.error("Error fetching event details:", err);
            setError("Failed to load event details.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEventDetails();
    }, [slug]);

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-5 text-center text-danger">
                <p>{error}</p>
            </div>
        );
    }

    if (!event) {
        return (
            <div className="container py-5 text-center text-muted">
                <p>No event found for this slug.</p>
            </div>
        );
    }

    return (
        <>
            {/* Header */}
            <div className="container-fluid bg-primary py-5 mb-5 page-header">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h1 className="display-3 text-white animated slideInDown">Event Details</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center">
                                    <li className="breadcrumb-item">
                                        <Link className="text-white" to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link className="text-white" to="/events">Events</Link>
                                    </li>
                                    <li className="breadcrumb-item text-white active" aria-current="page">
                                        {event.title}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Event Details */}
            <section id="event-singel" class="pt-120 pb-120 gray-bg">
                <div class="container">
                    <div class="events-area">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="events-left">
                                    <h3>{event.title}</h3>
                                    <Link to="#"> <span>
                                        <i className="fa fa-calendar"></i>{" "}
                                        {new Date(event.event_date).toLocaleDateString("en-GB", {
                                            day: "numeric",
                                            month: "long",
                                            year: "numeric",
                                        })}
                                    </span></Link>
                                    <Link to="#">
                                        <span><i class="fa fa-clock"></i> {event.start_time} - {event.end_time} </span>
                                    </Link>
                                    <Link to="#"><span><i class="fa fa-map-marker"></i> {event.location} </span></Link>
                                    <img src={event.image} className="img-fluid" alt={event.title}  />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: event.description,
                                        }}
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="events-right">
                                    {/* Countdown section */}
                                    <div class="events-coundwon bg_cover" data-overlay="8" style={{ backgroundImage: ` url(/assets/img/coundown.jpg)` }}>
                                      <center>
                                        <Countdown targetDate={event.event_date} />

                                        <div className="events-countdown-btn pt-30">
                                            <Link to="" target="_blank"  className="main-btn">
                                                Book Your Seat
                                            </Link>
                                        </div>
                                      </center>
                                    </div>

                                    <div class="events-address mt-30">
                                        <ul>
                                            <li>
                                                <div class="singel-address">
                                                    <div class="icon">
                                                        <i class="fa fa-clock"></i>
                                                    </div>
                                                    <div class="cont">
                                                        <h6>Start Time</h6>
                                                        <span>12:00 Am</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="singel-address">
                                                    <div class="icon">
                                                        <i class="fa fa-bell-slash"></i>
                                                    </div>
                                                    <div class="cont">
                                                        <h6>Finish Time</h6>
                                                        <span>05:00 Am</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="singel-address">
                                                    <div class="icon">
                                                        <i class="fa fa-map"></i>
                                                    </div>
                                                    <div class="cont">
                                                        <h6>Address</h6>
                                                        <span>Street Park ,America</span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EventsDetails;
